import React, { useRef, useEffect } from 'react';

function MelodyChart(props) {
    const canvasRef = useRef(document.getElementById("canvas-1"));
    const canvasHeight = 128;
    const canvasWidth = 300;
    
    let sequenceLength = 0;
    for (let x = 0; x < props.sequence.length; x++) {
        sequenceLength += props.sequence[x].duration;                        
    };
    const xWidth = 300/sequenceLength;
    const yHeight = canvasHeight/128;

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        let position = 0;
        for (let x = 0; x < props.sequence.length; x++) {
            if (props.sequence[x].constructor.name === 'Note') {
                context.fillRect(position, canvasHeight - props.sequence[x].midiNote, xWidth * props.sequence[x].duration, yHeight);
            }
            position += props.sequence[x].duration * xWidth;                      
        };
    }, [props, xWidth, yHeight]);

    return (
        <div>
            <canvas id={`canvas-${props.number}`} className="melodyCanvas" ref={canvasRef} width={canvasWidth} height={canvasHeight}/>
        </div>
    );
};

export default MelodyChart